import { Component, OnDestroy, OnInit } from '@angular/core';
import { untilViewDestroyed } from '@sd-portal/shared/rxjs';
import { CsatFacade } from '../+state/csat.facade';
import { CsatModalService } from '../csat-modal.service';

interface IQuestion {
  id: number,
  text: string
}

@Component({
  selector: 'sd-portal-csat-modal',
  templateUrl: './csat-modal.component.html',
  styleUrls: ['./csat-modal.component.scss'],
})

export class CsatModalComponent implements OnInit, OnDestroy {
  question: IQuestion | null;
  value: number = 0;
  comment: string

  constructor(
    readonly csatModalService: CsatModalService,
    private readonly csatFacade: CsatFacade
  ){}

  ngOnInit() {
    this.csatFacade.questions$
      .pipe(untilViewDestroyed(this))
      .subscribe(questions => {
        if(questions) this.question = questions[0]
      })
  }

  close(): void {
    const userAnswer = {
      satisfactionAnswersList: [{
        satisfactionQuestionId: this.question?.id,
        rating: this.value,
        comment: this.comment
      }]
    }
    this.csatFacade.saveUserAnswer(userAnswer)
    this.csatModalService.setOpenModal(false)
  }

  setValue(value: number): void {
    this.value = value
  }

  sendFeedback() {
    const userAnswer = {
      satisfactionAnswersList: [{
        satisfactionQuestionId: this.question?.id,
        rating: this.value,
        comment: this.comment
      }]
    }
    this.csatFacade.saveUserAnswer(userAnswer)
  }

  ngOnDestroy() {
  }
}
